import { createContext, type PropsWithChildren, useContext } from 'react';
import type { ServiceBillingGateway } from '@forq/service-billing-data';

/**
 * Woher die Service-Rechnungsvorschläge kommen:
 *   session-demo     nur im Arbeitsspeicher (Demo-Betrieb ohne Datenbank) -- beim Neuladen weg
 *   supabase         Produktivbetrieb, `public.service_billing_proposals`
 *   supabase-preview getrennte Vorschaudatenbank, Schema `forq_next_preview`
 */
export interface PreviewPersistenceContextValue {
  readonly mode: 'session-demo' | 'supabase' | 'supabase-preview';
  readonly billingGateway: ServiceBillingGateway;
}

const PreviewPersistenceContext = createContext<PreviewPersistenceContextValue | null>(null);

export function PreviewPersistenceProvider({
  children,
  value,
}: PropsWithChildren<{ readonly value: PreviewPersistenceContextValue }>) {
  return (
    <PreviewPersistenceContext.Provider value={value}>
      {children}
    </PreviewPersistenceContext.Provider>
  );
}

export function usePreviewPersistence(): PreviewPersistenceContextValue {
  const context = useContext(PreviewPersistenceContext);
  if (!context) throw new Error('usePreviewPersistence must be used inside PreviewPersistenceProvider.');
  return context;
}
